import React, { Fragment } from 'react';

import { AutoreviewFooter } from 'src/components/autoreview-feedback/src/autoreview-footer';
import { FabricComment } from 'src/components/conversation-provider/types';
import { CreateJiraIssueFormPr } from 'src/sections/repository/sections/jira/components/create-jira-issue/create-jira-issue-form-pr';
import { JiraIssues } from 'src/sections/repository/sections/jira/components/jira-issues/jira-issues';

import { TaskList } from '../../components/tasks/task-list';

export const AfterCommentItems = ({ commentId, createdBy }: FabricComment) => {
  return (
    <Fragment>
      <TaskList commentId={commentId.toString()} />
      <JiraIssues commentId={commentId} />
      <CreateJiraIssueFormPr commentId={commentId} />
      <AutoreviewFooter createdById={createdBy.id} />
    </Fragment>
  );
};
